// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const riskRatingOperations = {
  getSupplierRatings: ['get', '/v1/risk-ratings/{supplierNumber}'] as const,
  getRatingsForAllSuppliers: [
    'post',
    '/v1/risk-ratings/suppliers/all'
  ] as const,
  getRiskRatings: ['post', '/v1/risk-ratings/suppliers/risk'] as const,
  getRiskRatingsHub: ['post', '/v1/risk-ratings/suppliers/risk/hub'] as const,
  getFinancialRating: [
    'get',
    '/v1/risk-ratings/financial/{supplierNumber}'
  ] as const,
  getFinancialInfo: [
    'get',
    '/v1/risk-ratings/financial/info/{supplierNumber}'
  ] as const,
  getAllFinancialInfo: ['post', '/v1/risk-ratings/financial/info/all'] as const,
  getBusinessContinuityRatings: ['post', '/v1/risk-ratings/bc'] as const
} as const;
